<template>
  <b-modal :id="modalId" centered hide-footer @hidden="$emit('close')">
    <template #modal-title>Edit Member Roles</template>
    <b-form @submit.prevent="saveRoles">
      <b-form-group label="Roles">
        <b-form-checkbox-group v-model="selectedRoles">
          <b-form-checkbox
            v-for="role in org.roles"
            :disabled="role.name === 'Owner' && !canSetOwner"
            :key="role.id"
            :value="role.id"
            class="d-block mb-2"
          >
            <div>{{ role.name }}</div>
            <div class="small text-muted">{{ role.description }}</div>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <div class="mt-4 text-right">
        <b-btn class="ml-2" variant="secondary" @click="closeModal">
          Cancel
        </b-btn>
        <b-btn class="ml-2" type="submit" variant="primary">Save</b-btn>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import API from "@/api";

export default {
  props: {
    org: {
      type: Object,
      required: true
    },
    isOwner: {
      type: Boolean,
      default: false
    },
    memberId: {
      type: Number,
      default: null
    },
    memberRoles: {
      type: String,
      default: null
    },
    modalId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    selectedRoles: []
  }),

  computed: {
    ...mapGetters(["isAdmin", "hasPermission"]),

    canSetOwner() {
      return this.isAdmin || this.hasPermission("org.edit") || this.isOwner;
    }
  },

  watch: {
    memberRoles: {
      immediate: true,
      handler(newRoles) {
        if (!newRoles) return [];
        const roleNames = newRoles.split(",");
        this.selectedRoles = this.org.roles
          .filter(role => roleNames.includes(role.name))
          .map(role => role.id);
      }
    }
  },

  methods: {
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
    async saveRoles() {
      if (this.memberId === null) return;
      const { success } = await API.updateOrgMemberRoles(
        this.org.id,
        this.memberId,
        this.selectedRoles
      );
      if (success) {
        this.$emit("updated");
        this.closeModal();
      }
    }
  }
};
</script>
